import React from 'react'
import classnames from 'classnames'
import styles from './styles.module.scss'

const HorizontalLoader = (props) => <div className={classnames(styles.loader, props.className)} />

export default HorizontalLoader
